import * as React from 'react'
import { TableHead, TableRow, TableCell, TableBody, Table, makeStyles, TableContainer, createTheme } from "@material-ui/core"
import { PackagePriceRow } from '@tfo/common/src/interfaces/PackagePrice'
import { useIntl } from "react-intl"
import { Elements } from '@tfo/common'
const PackagePriceTable = ({ packagePriceRows }: { packagePriceRows: Array<PackagePriceRow> }) => {
    const defaultTheme = createTheme()
    const { Paragraph } = Elements
    const useStyles = makeStyles({
        table: { display: 'flex', flexDirection: 'column', width: '100%', maxWidth: '100%', border: '1px solid #ec9dc9', margin: '1em 0' },
        head: { display: 'block', [defaultTheme.breakpoints.down('xs')]: { overflowY: 'hidden' }, backgroundColor: '#ec9dc9' },
        headRow: { display: 'flex', width: '100%' },
        cell: { display: 'flex', flex: '1 0', overflow: 'hidden', alignItems: 'flex-start', justifyContent: 'flex-start', padding: '0.5rem 0.75rem' },
        cellAlignRight: { display: 'flex', flex: '1 0', overflow: 'hidden', alignItems: 'flex-end', justifyContent: 'flex-end', padding: '0.5rem 0.75rem' },
        body: { flex: '1', overflow: 'overlay', display: 'block', maxHeight: '40rem' },
        bodyRow: { width: '100%', display: 'flex', height: '4rem', '&:hover': { cursor: 'default' } },
        longNames: {overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'},
        teableHeadlines: { color: 'white', fontStyle: 'bold' },
        tableBodyHeadlines: { fontWeight: 600, padding: '0.2rem' }
    })
    const styles = useStyles()
    const intl = useIntl()
    const isTitle = (priceRow: PackagePriceRow): boolean => {
        return !(priceRow?.price || priceRow?.days)
    }

    return (
        <>
            <TableContainer>
                <Table className={styles.table}>
                    <TableHead className={styles.head}>
                        <TableRow className={styles.headRow}>
                            <TableCell className={styles.cell}>
                            </TableCell>
                            <TableCell className={styles.cellAlignRight}>
                                <Paragraph className={styles.teableHeadlines}>{intl.formatMessage({ id: 'common.myAccount.cost' })}</Paragraph>
                            </TableCell>
                            <TableCell className={styles.cell}>
                                <Paragraph className={styles.teableHeadlines}>{intl.formatMessage({ id: 'common.deliveryDays' })}</Paragraph>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className={styles.body}>
                        <TableRow className={styles.bodyRow}>
                            <TableCell className={styles.cell}>
                                <Paragraph className={styles.tableBodyHeadlines}>{intl.formatMessage({ id: 'common.sweden' })}</Paragraph>
                            </TableCell>
                            <TableCell className={styles.cell}></TableCell>
                            <TableCell className={styles.cell}></TableCell>
                        </TableRow>
                        {
                            packagePriceRows.map((p, index) => {
                                return (
                                    <TableRow key={index} className={styles.bodyRow}>
                                        {isTitle(p) ?
                                            <>
                                                <TableCell className={styles.cell}>
                                                    <Paragraph className={styles.tableBodyHeadlines}>{p.name}</Paragraph>
                                                </TableCell>
                                            </>
                                            :
                                            <>
                                                <TableCell className={styles.cell}>
                                                    <Paragraph className={styles.longNames}>{p.name}</Paragraph>
                                                </TableCell>
                                                <TableCell className={styles.cellAlignRight}>
                                                    <Paragraph>{`${p?.price} ${intl.formatMessage({ id: 'common.currency.suffix' })}`}</Paragraph>
                                                </TableCell>
                                                <TableCell className={styles.cell}>
                                                    <Paragraph>{p?.days} </Paragraph>
                                                </TableCell>
                                            </>
                                        }
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>

    )
}
export default PackagePriceTable